import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Pagination from '../../../../../../components/Pagination';
import ItemShimmer from '../../../../../../components/Shimmer/itemShimmer';


const ItemsTable = ({ total_count, items,searchParams,setSearchParams,handleSearch ,loading,handleOnClickPageNumber}) => {
    const [suggestions, setSuggestions] = useState("");
    const [isClearVisible, setIsClearVisible] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumber, setPageNumber ] = useState(1)
    const itemsPerPage = 10;
    console.log('items',items)

    const handleStatus = (status) => {
        const val = {
            Promoted: { 
                status: true,
                img: "successDot.svg", 
                color: "bg-[#C5FFD5]" 
            },
            "Not Promoted": { 
                status: false, 
                img: "inactive-Dot.svg", 
                color: "bg-[#FFEEB0]" 
            }
        };
        return val[status] || val["Not Promoted"];
    } 

    const handleChange = (e) => {
        setSuggestions(e.target.value);
        setIsClearVisible(e.target.value !== "");
    };

    useEffect(() => {
        const pages = Math.ceil(total_count / itemsPerPage) || 1;
        if (pages !== totalPages) {
            console.log('Updating totalPages');
            setTotalPages(pages);
        }
    }, [total_count, itemsPerPage, totalPages]);

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            console.log("Search triggered, resetting to page 1");
            const params = Object.fromEntries(searchParams);
            setSearchParams({
                ...params,
                student_page_number: 1,
                search: suggestions,
            });
        }
    };


    const clearAndperformSearch = () => {
        console.log("Clearing search, resetting to page 1");
        setSuggestions("");
        setIsClearVisible(false);
        const params = Object.fromEntries(searchParams);
        delete params.search;
        setSearchParams({ ...params, student_page_number: 1 });
    };    



    // Get current items for the page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = items?.slice(indexOfFirstItem, indexOfLastItem) || [];

    return (
        <div className="w-full mt-2">
            <div className="flex justify-end mb-2">
                <div className="relative search-tab">
                    <label htmlFor="input"></label>
                    <div className="absolute top-[52%] -translate-y-[50%]" id="search_button">
                        <button
                            type="button"
                            id="search-button"
                            className="inline-block"
                            data-te-toggle="modal"
                            data-te-target="#exampleModalCenter"
                            data-te-ripple-init
                            data-te-ripple-color="light"
                        >
                            <img 
                                loading="lazy" 
                                decoding="async" 
                                src="/images/search.svg" 
                                alt="img"
                            />
                        </button>
                    </div>
                    <div className="relative flex">
                        <input
                            maxLength={90}
                            type="text"
                            id="search-value"
                            autoComplete="off"
                            value={suggestions}
                            autoFocus={suggestions !== ""}
                            onChange={handleChange}
                            onKeyPress={handleKeyPress}
                            placeholder="Student Name / ID" 
                        />
                    </div>
                    {isClearVisible && (
                        <div 
                            className="absolute cross_icon" 
                            id="clear_icon" 
                            onClick={clearAndperformSearch} 
                            title="Clear Search"
                        />
                    )}
                </div>
            </div>
            {loading ? <ItemShimmer /> : <>
                <div className="overflow-hidden">
                    <table aria-label="Outside Table" className="w-full greyHeader" id="admin-table">
                        <thead>
                            <tr>
                                <th className="px-6 py-4 text-left w-[40%]">Student Name</th>
                                <th className="px-6 py-4 text-left  w-[20%]">Record ID</th>
                                <th className="px-6 py-4 text-left  w-[20%]">Gender</th>
                                <th className="px-6 py-4 text-left  w-[20%]">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length > 0 ? (
                                currentItems.map((item, index) => (
                                    <tr key={index} className="border-t">
                                        <td className="px-6 py-4">{item.student_name}</td>
                                        <td className="px-6 py-4">{item.student_id}</td>
                                        <td className="px-6 py-4">{item.gender}</td>
                                        <td className="cursor-pointer table-cell">
                                            <div className="flex justify-start">
                                                {(() => {
                                                    const statusKey = item.promote_status ? "Promoted" : "Not Promoted"
                                                    const statusData = handleStatus(statusKey)
                                                    return (
                                                        <div className={`w-fit rounded ${statusData.color} flex items-center 
                                                        justify-center py-1.5 px-2 2xl:px-2.5`}>
                                                            <img loading="lazy" decoding="async"
                                                                src={`/images/${statusData.img}`} alt="icon" />
                                                            <span className="text-f7 font-normal text-[#031624] pl-1">
                                                                {statusKey}
                                                            </span>
                                                        </div>
                                                    )
                                                })()}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="px-6 py-4 text-center">No data available</td>
                                </tr>
                            )}
                        </tbody>
                        {total_count === 0 && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px' }} colspan="4" className="no-records-message" 
                                        id='no-matching-result'>
                                        {'No records found'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                    
                </div>
                {total_count > 10 && (
                    <Pagination
                        TotalCount={total_count}
                        totalPageNumber={totalPages}
                        selectedPageNumber={Number(searchParams.get('student_page_number')) || 1}
                        handleOnClickPageNumber={handleOnClickPageNumber}
                        limit={itemsPerPage}
                    />
                )}
            </>}
            
        </div>
    );
};
ItemsTable.propTypes = {
    items: PropTypes.array.isRequired
};

export default ItemsTable;